import React, { useEffect, useState } from "react"
import { useStore } from "../../../../stores/RootStoreContext"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { IClientCurrencyRate } from "../../../../types/client/IClientCurrencyRate"
import { ModalPopUp } from "../../element/ModalPopUp"
import { IModalMessage } from "../../../../types/error/IModalMessage"
import { ClientCurrencyRatePopUp } from "./ClientCurrencyRatePopUp"

export const ClientCurrencyRate: React.FC<{ userId: number }> = ({ userId }) => {
  const { userStore } = useStore()
  const [currencyRates, setCurrencyRates] = useState<IClientCurrencyRate[]>([])
  const [rate, setRate] = useState<IClientCurrencyRate | undefined>()
  const [popUpVisibility, setPopUpVisibility] = useState(false)
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)

  useEffect(() => {
    getRates()
  }, [])

  const getRates = () => {
    TrinityAPI.getClientCurrencyRates(userId, response => {
      if (response.status === 200) {
        setCurrencyRates(response.data)
      }
    })
  }

  const deleteRate = (rateId: string | undefined) => {
    if (!rateId) return
    TrinityAPI.deleteClientCurrencyRate(rateId, response => {
      if (response.status === 200) {
        getRates()
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка при удалении ставки: " + response.data.message })
      }
    })
  }

  const showPopUp = (currentRate: IClientCurrencyRate | undefined) => {
    if (!userStore.isAdmin) return
    if (!currentRate) {
      currentRate = { clientId: userId }
    }
    setRate(currentRate)
    setPopUpVisibility(true)
  }

  const hidePopUp = () => {
    getRates()
    setRate(undefined)
    setPopUpVisibility(false)
  }

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <div className="form-block-popup">
        <h4 className="heading-chapter">Надбавка к курсу</h4>
        {currencyRates?.map((cr, index) => (
          <div className="flex-row-24" key={index}>
            <div className="condition" onClick={() => showPopUp(cr)}>
              {cr.currency} + {cr.value} {cr.type === "PCT" ? "%" : "коп."}
            </div>
            {userStore.isAdmin ? <div className="delete-button" onClick={() => deleteRate(cr.id)} /> : null}
          </div>
        ))}
        {userStore.isAdmin && (
          <div className="button-file" onClick={() => showPopUp(undefined)}>
            Добавить
          </div>
        )}
      </div>
      {popUpVisibility ? <ClientCurrencyRatePopUp rate={rate} hidePopUp={hidePopUp} /> : <></>}
    </>
  )
}
